<script>
  import { onMount } from "svelte"
  import { querystring, push } from "svelte-spa-router"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import notify from "../../../../../Script/notify"
  import LoadingScreen from "../../../SinglePublish/Components/loadingScreen.svelte"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import BadgePublish, { updateBadgePublish } from "../../Stores/badge"
  import { fetchBadgeData, fetchDocumentDetails } from "../../Script/api"
  import { copyToClipboard } from "../../../SinglePublish/script"
  import Dropdown from "../../../../../Shared/textDropdown.svelte"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import ImagePreviewModel from "./Components/imagePreviewModel.svelte"

  /**
   * @type {Object} - object get from window location
   */
  let query = {}

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let showLoading = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  /**
   * @type {Boolean} - whether to show a confirmation model or not
   */
  let showDocPreviewModal = false

  let policyType = "CSP Policy"

  /**
   * @type {String} -Embed code content for the body tag
   */
  let divTag = ""
  //For test env

  let cspStatic = $ApplicationState.cspStatic ? $ApplicationState.cspStatic.replace("https://", "").split("/")[0] : ""
  // console.log({ cspStatic })

  let badgeBase = $ApplicationState.badgeBase.replace("https://", "").split("/")[0]
  // console.log({ badgeBase })

  let scriptTag = `%3Cscript%20type%3D"module"%20src%3D"https%3A%2F%2F${cspStatic || badgeBase}%2fbadge%2flink.min.js"%3E%3C%2Fscript%3E`
  //For demo env
  // let scriptTag = `%3Cscript%20type%3D"module"%20src%3D"https%3A%2F%2Fprint2block.com%2Fdemo-badge-v2%2Flink.js"%3E%3C%2Fscript%3E`
  //For normal env
  // let scriptTag = `%3Cscript%20type%3D"module"%20src%3D"https%3A%2F%2Fprint2block.com%2Fbadge-v2%2Flink.js"%3E%3C%2Fscript%3E`

  // let csp = {
  //   "CSP Policy": `default-src 'self';
  //   script-src 'wasm-unsafe-eval' 'self' https://print2block.com;
  //   style-src 'self' https://print2block.com;
  //   connect-src 'self' https://print2block.com;
  //   form-action 'self' https://test.view.print2block.in;
  //   object-src 'none';
  //   base-uri 'self';
  //   font-src 'self';
  //   frame-ancestors 'none';
  //   img-src 'self' https://test.view.print2block.in;
  //   manifest-src 'self';
  //   media-src 'self';
  //   worker-src 'self' https://print2block.com;`,
  //   "HTML CSP Policy": `<meta
  //     http-equiv="Content-Security-Policy"
  //     content="
  //   default-src 'self';
  //   script-src 'wasm-unsafe-eval' 'self' https://print2block.com;
  //   style-src 'self' https://print2block.com;
  //   connect-src 'self' https://print2block.com;
  //   form-action 'self' https://test.view.print2block.in;
  //   object-src 'none';
  //   base-uri 'self';
  //   font-src 'self';
  //   frame-ancestors 'none';
  //   img-src 'self' https://test.view.print2block.in;
  //   manifest-src 'self';
  //   media-src 'self';
  //   worker-src 'self' https://print2block.com;"
  //   />`,
  //   "Nginx CSP Policy": `add_header Content-Security-Policy "default-src 'self';
  //   script-src 'wasm-unsafe-eval' 'self' https://print2block.com;
  //   style-src 'self' https://print2block.com;
  //   connect-src 'self' https://print2block.com;
  //   form-action 'self' https://test.view.print2block.in;
  //   object-src 'none';
  //   base-uri 'self';
  //   font-src 'self';
  //   frame-ancestors 'none';
  //   img-src 'self' https://test.view.print2block.in;
  //   manifest-src 'self';
  //   media-src 'self';
  //   worker-src 'self' https://print2block.com;"`,
  // }

  cspStatic = cspStatic ? `https://${cspStatic}` : ""
  // console.log({ viewBase })

  badgeBase = `https://${badgeBase}`
  // console.log({ badgeBase })

  let viewBase = $ApplicationState.viewBase.replace("https://", "").split("/")[0]
  // console.log({ viewBase })
  viewBase = `https://${viewBase}`
  // console.log({ viewBase })

  let csp = {
    "CSP Policy": `default-src 'self'; 
    script-src 'wasm-unsafe-eval' 'self' ${cspStatic || badgeBase};
    style-src 'self' ${cspStatic || badgeBase}; 
    form-action 'self' ${$ApplicationState.cspAPI || badgeBase || ""} ${viewBase};
    frame-ancestors 'none';
    img-src 'self' ${viewBase};
    connect-src 'self' ${cspStatic || badgeBase};`,

    "HTML CSP Policy": `<meta
    http-equiv="Content-Security-Policy"
    content="default-src 'self'; 
    script-src 'wasm-unsafe-eval' 'self' ${cspStatic || badgeBase};
    style-src 'self' ${cspStatic || badgeBase}; 
    form-action 'self' ${$ApplicationState.cspAPI || badgeBase || ""} ${viewBase};
    frame-ancestors 'none'; 
    img-src 'self' ${viewBase};
    connect-src 'self' ${cspStatic || badgeBase};"
    />`,

    "Nginx CSP Policy": `add_header Content-Security-Policy "default-src 'self'; 
    script-src 'wasm-unsafe-eval' 'self' ${cspStatic || badgeBase};
    style-src 'self' ${cspStatic || badgeBase}; 
    form-action 'self' ${$ApplicationState.cspAPI || badgeBase || ""} ${viewBase};
    frame-ancestors 'none'; 
    img-src 'self' ${viewBase};
    connect-src 'self' ${cspStatic || badgeBase};"`,
  }

  /**
   * @type {String} - active CSP content
   */
  let activeCSP = csp["CSP Policy"]

  /**
   * @type {copiedInfo}
   */
  let copiedInfo = {
    close() {},
  }

  /**
   * fetch new document id details or store qrcode value to local storage
   */
  onMount(async () => {
    try {
      showLoading = true
      query = queryStringToJSON($querystring)
      // let badgeDetails = localStorage.getItem("P2BBadgePublish")

      $BadgePublish = {}

      // console.log($BadgePublish)

      if (query.badgeId) {
        let badgeData = await fetchBadgeData(query.badgeId) // presisting badge data
        // console.log({ badgeData })
        // console.log(badgeData.documentID, "For API call")
        let docData = await fetchDocumentDetails(badgeData.documentID)
        delete docData.id
        // console.log({ docData })

        badgeData = { ...badgeData, ...docData }
        // console.log({ badgeData })

        assignFetchedData(badgeData)
      }
      divTag = `<div class="p2b-badge" data-badge-src="${cspStatic || badgeBase}" data-badge-id="${query.badgeId}"></div>`

      // console.log($BadgePublish)
      // updateBadgePublish($BadgePublish)
    } catch (error) {
      if (error == "P2BCODE::DOCUMENT_DOES_NOT_EXIST") removeDataBadgePublish(query.documentId)
      BadgePublish.update((badgePub) => {
        return (badgePub = {})
      })
      const info = "PAGE: Badge Publish (Badge Info)\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      // placeBadge()
      showLoading = false
    }
  })

  /**
   * @description function for start a new single publish process.
   */
  const clearAndUpdate = () => {
    localStorage.removeItem("P2BSinglePublish")
    $BadgePublish = {}
    updateBadgePublish($BadgePublish)
    push("/publish/badge")
  }

  const assignFetchedData = (data) => {
    try {
      // console.log(data)

      $BadgePublish.badgeId = data.id
      $BadgePublish.domain = data.domain
      $BadgePublish.reference = data.name.trim()
      $BadgePublish.documentId = data.documentID
      $BadgePublish.image = `/ipfs/${data.image}`
      if (data.metadata) $BadgePublish.metadata = JSON.parse(data.metadata)
      if (data.options) $BadgePublish.options = JSON.parse(data.options)
      if (data.dataHash) $BadgePublish.dataHash = data.dataHash
      if (data.fileHash) {
        $BadgePublish.uri = `/ipfs/${data.filename}`
        $BadgePublish.fileHash = data.fileHash
      }
      if (data.url) $BadgePublish.proposedURL = $ApplicationState.viewBase.replace("/v2/", `/v${data.version}/`) + data.url
      if (data.txidPublished) $BadgePublish.txid = data.txidPublished

      // console.log($BadgePublish)

      updateBadgePublish($BadgePublish)
    } catch (error) {
      // console.error(error)
      throw "Error While Processing Data"
    }
  }

  const handleResume = () => {
    try {
      let path
      if (!$BadgePublish.badgeId) path = "badgetemplate"
      // else if ($BadgePublish.dataHash) path = "doctemplate"
      else if (!$BadgePublish.fileHash) path = "doctemplate"
      else if (!$BadgePublish.txid) path = "preview"
      else path = "final"
      // if (!$BadgePublish.badgeId) push(`/publish/badge`)
      // else {
      // push(`/publish/badge/${path}?documentId=${$BadgePublish.documentId}${query.badgeId ? "&badgeId=" + query.badgeId : ""}`)
      push(`/publish/badge/${path}?documentId=${$BadgePublish.documentId}&badgeId=${$BadgePublish.badgeId}`)
      // }
      // console.log("resume")
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Publish (Badge Info)\nEVENT: During Badge publish resume"
      notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>Publish Badge</title>
</svelte:head>

{#if showDocPreviewModal}
  <ImagePreviewModel
    on:click={() => {
      showDocPreviewModal = false
    }}
    link={$BadgePublish.uri}
  />
{/if}

{#if showLoading}
  <LoadingScreen msg="Fetching document Details" />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="mx-auto h-auto w-full max-w-[920px] px-6 pb-40 pt-3 lg:px-0">
    <div class="flex gap-3 pt-6">
      <div class="relative flex min-h-[470px] w-full flex-col gap-3 rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <div class="select-none space-y-3">
          <h1 class="text-3xl font-bold leading-snug dark:text-white mobile:text-4xl">Badge Info{@html $BadgePublish.proposedURL ? "" : `&nbsp;&nbsp;<i class="fa-solid fa-triangle-exclamation text-yellow-500"></i>`}</h1>

          <p class="w-full break-words text-justify text-sm text-gray-500 dark:text-gray-300 mobile:text-base">
            {@html $BadgePublish.txid ? "This section displays the details of your badge, including its associated document and domain restrictions" : "You haven't published the document linked to this badge yet. Please click the <strong>resume</strong> button below to complete the publication."}
          </p>
        </div>

        <div class="w-full space-y-3 pt-6">
          <!-- {#if !$BadgePublish.proposedURL}
            <p class="w-full break-words pt-6 text-justify text-sm font-bold dark:text-white mobile:text-base">Badge</p>
          {/if} -->
          <div class="flex w-full flex-col gap-6 truncate dark:text-gray-300 md:flex-row md:items-center">
            <div class="">
              <img src={$BadgePublish.image} alt="badgeImage" class="aspect-auto h-auto max-h-[200px] rounded-md" />
              <!-- <div class="p2b-badge" data-badge-id={$BadgePublish.badgeId} /> -->
            </div>
            <div class="w-full space-y-3 truncate">
              <div class="space-y-3 truncate">
                <div class="flex flex-col truncate">
                  <span class="text-gray-500 dark:text-gray-300">Badge Locked Domain</span>
                  <div class="flex items-center gap-3 truncate dark:text-white">
                    <i class="fa-solid fa-badge-check text-green-500" />
                    <span class="truncate">{$BadgePublish.domain}</span>
                    <i class="fa-solid fa-lock" />
                  </div>
                  <!-- <span class="truncate text-gray-500">(Badge Locked Domain)</span> -->
                </div>
                <div class="truncate">
                  <span class="text-gray-500 dark:text-gray-300">Badge Name</span>
                  <p class="truncate dark:text-white">{$BadgePublish.reference || "Name did'n provided"}</p>
                </div>
              </div>
              <div class="flex flex-col gap-3 sm:flex-row md:items-center">
                {#if $BadgePublish.txid}
                  <button on:click={() => (showDocPreviewModal = true)} class="flex h-9 w-fit min-w-fit cursor-pointer items-center justify-center gap-3 rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 sm:ml-0 lg:px-4">
                    <i class="fa-solid fa-eye" />
                    <span>View&nbsp;Document</span>
                  </button>
                  <a href="#/analytics/documents/send-email?id={query.documentId}&badgeId={query.badgeId}&cspPolicy={policyType}" target="_blank" data-tooltip="Embed code and {policyType} to the team" tooltip-position="top" class="flex h-9 w-fit min-w-fit cursor-pointer items-center justify-center gap-3 rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300 sm:ml-0 lg:px-4">
                    <i class="fa-solid fa-envelope" />
                    <span>Send&nbsp;Email</span>
                  </a>
                {:else}
                  <button type="button" on:click={handleResume} class="flex h-9 w-fit min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
                    <i class="fa-solid fa-circle-play" />
                    <span class="select-none">&nbsp;&nbsp;Resume&nbsp;</span>
                  </button>
                {/if}
              </div>
            </div>
          </div>

          {#if $BadgePublish.txid}
            <p class="w-full break-words pt-6 text-justify text-sm font-bold dark:text-white mobile:text-base">
              Embed code in the {`<body>`} of your HTML page
            </p>
            <div class="break-all rounded-md bg-[#f7f7f7] px-4 py-2 text-gray-500 dark:bg-bodyblack dark:text-gray-300">
              <p>
                {divTag}
              </p>
              <p>{decodeURIComponent(scriptTag)}</p>
              <button
                on:click={async () => {
                  copiedInfo.close()
                  await copyToClipboard(`${divTag}\n` + decodeURIComponent(scriptTag))
                  copiedInfo = notify.info("Embed code copied to clipboard")
                }}
                class="ml-auto flex items-center gap-2 text-gray-500 dark:text-gray-300"
              >
                <div>
                  <i class="fa-solid fa-copy" />
                </div>
                <p>Copy</p>
              </button>
            </div>

            <div class="flex w-full flex-col items-start justify-between gap-3 pt-6 md:flex-row">
              <div class="flex w-full items-center gap-3 md:w-full">
                <p class="w-fit break-words text-justify text-sm font-bold dark:text-white mobile:text-base">{policyType}</p>
                <a data-tooltip="What is CSP Policy" tooltip-position="right" target="_blank" href="https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP" class="flex items-center gap-3 text-gray-500 hover:text-blue-500 dark:text-gray-300 dark:hover:text-blue-500">
                  <i class="fa-solid fa-circle-question" />
                </a>
              </div>
              <div class="w-[200px]">
                <Dropdown
                  dropdownItems={["CSP Policy", "Nginx CSP Policy", "HTML CSP Policy"]}
                  bind:selected={policyType}
                  on:itemSelect={(e) => {
                    policyType = e.detail
                    activeCSP = csp[policyType]
                    // dispatch("changeEntries", { entries: entries, activePage: activePage, sort: sortByDateFile ? 1 : -1 })
                  }}
                />
              </div>
            </div>
            <div class="rounded-md bg-[#f7f7f7] px-4 py-2 dark:bg-bodyblack">
              <p class="text-gray-500 dark:text-gray-300">
                {activeCSP}
              </p>
              <button
                on:click={async () => {
                  copiedInfo.close()
                  await copyToClipboard(activeCSP)
                  copiedInfo = notify.info(`${policyType} copied to clipboard`)
                }}
                class="ml-auto flex items-center gap-2 text-gray-500 dark:text-gray-300"
              >
                <div>
                  <i class="fa-solid fa-copy" />
                </div>
                <p>Copy</p>
              </button>
            </div>
          {/if}
        </div>
        <!-- {#if $BadgePublish.proposedURL}
          <div class="flex justify-center">
            <button type="button" on:click={clearAndUpdate} class="flex h-9 w-auto min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 sm:ml-0 lg:px-4">
              <i class="fa-solid fa-upload" />
              <span class="select-none">&nbsp;&nbsp;Publish another badge&nbsp;</span>
            </button>
          </div>
        {/if} -->
      </div>
    </div>
  </div>
  <Footer />
</div>
